import React from 'react';
import styles from '../../Popover.scss.js';
import { Box } from '../../../Box/Box.js';

function Section({
  children
}) {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.Section
  }, /*#__PURE__*/React.createElement(Box, {
    padding: "4"
  }, children));
}

export { Section };
